import { useContext, useEffect } from 'react';
import { AppContext } from 'providers/AppProvider';
import { buildAnswer, IsBoolChoice, IsInline, isQuestionVisible } from 'helpers';
import { QuestionProps, QuestionType } from 'types';
import { removeAnswers } from 'store/actions';

export function useQuestion(props: QuestionProps) {
	const { choices, dependsOnQuestionId, id, isSubquestion, questionType, testId } = props;
	const { dispatch, state, t } = useContext(AppContext);
	const depended = Number.isInteger(dependsOnQuestionId);
	const isBool = IsBoolChoice(choices);
	const inline = IsInline(choices);
	const framed = inline && !isBool;
	const isDropdown = !!(isSubquestion && !isBool && QuestionType.RadioMatrix === questionType);
	const iconTitle = t(`question_${id}_icon_title`, 'riskq');
	const isVisible = isQuestionVisible(props, state.riskq);

	useEffect(() => {
		if (!isVisible) {
			dispatch([removeAnswers, { riskq: [buildAnswer(testId, id, 0)] }]);
		}
	}, [id, isVisible, testId, dispatch]);

	return {
		...props,
		depended,
		framed,
		iconTitle,
		isBool,
		isDropdown,
		isVisible
	};
}
